import HowItWorks from 'lowcode/OldMember/HowItWorks';
import { getIsLogin } from 'lowcode/utils/getIsLogin';
import { Fragment, useEffect, useState } from 'react';
import './index.scss';

export default function Content({ loginType }: any) {
    const [isLogin, setIsLogin] = useState(false);

    useEffect(() => {
        const isLogin2 = getIsLogin();
        setIsLogin(isLogin2);
    }, []);
    return (
        <Fragment>
            <HowItWorks isLogin={isLogin} loginType={loginType} />
        </Fragment>
    );
}
